module.exports = __webpack_public_path__ + "media/images/screens/09_devis-2395e638356a34a73a5f92900fa2694e.jpg";